import { getPlan, addOrUpdate, deletePlan} from "core/database/plan";
import ActionCreator from 'core/utils/redux/ActionCreator';

const { actions, defaultReducer, get, add, remove, update } = new ActionCreator("plan");
export { actions, defaultReducer };

export const getPlanData = get(getPlan);
export const addPlanData = add(addOrUpdate);
export const updatePlanData = update(addOrUpdate);
export const deletePlanData = remove(deletePlan);
